import axios from "axios"
const base64_encode = require("base-64")
import { storeUserToken } from "@/utils/secureStorage"
import { BASE_URLS } from "@/api/endpoints"

export const handleAuthenticate = async ({
  userName,
  password,
}: {
  userName: String
  password: String
}) => {
  const resp = await axios.post(
    BASE_URLS.AUTH_SERVER!,
    {},
    {
      headers: {
        Authorization:
          "Basic " + base64_encode.encode(userName + ":" + password),
        "Content-Type": "application/json",
      },
    },
  )
  const { token } = resp.data
  storeUserToken(token)
  return token
}
